import { Axios } from '../axios.interceptor';

const BASE = 'api/v1/admin/config';
const hdrs = (token) => ({
  headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
});

export const configApi = {
  listConfigs: (token) =>
    new Promise(async (resolve, reject) => {
      try { resolve(await Axios.get(`${BASE}/platform`, hdrs(token))); }
      catch (e) { reject(e?.response?.data || e); }
    }),

  getActiveConfig: (token) =>
    new Promise(async (resolve, reject) => {
      try { resolve(await Axios.get(`${BASE}/platform/active`, hdrs(token))); }
      catch (e) {
        if (e?.response?.status === 404) resolve(null);
        else reject(e?.response?.data || e);
      }
    }),

  createConfig: (token, data) =>
    new Promise(async (resolve, reject) => {
      try { resolve(await Axios.post(`${BASE}/platform`, data, hdrs(token))); }
      catch (e) { reject(e?.response?.data || e); }
    }),

  activateConfig: (token, id) =>
    new Promise(async (resolve, reject) => {
      try { resolve(await Axios.patch(`${BASE}/platform/${id}/activate`, {}, hdrs(token))); }
      catch (e) { reject(e?.response?.data || e); }
    }),

  listWhitelist: (token) =>
    new Promise(async (resolve, reject) => {
      try { resolve(await Axios.get(`${BASE}/whitelist`, hdrs(token))); }
      catch (e) { reject(e?.response?.data || e); }
    }),

  addToWhitelist: (token, data) =>
    new Promise(async (resolve, reject) => {
      try { resolve(await Axios.post(`${BASE}/whitelist`, data, hdrs(token))); }
      catch (e) { reject(e?.response?.data || e); }
    }),

  updateWhitelist: (token, sellerId, data) =>
    new Promise(async (resolve, reject) => {
      try { resolve(await Axios.put(`${BASE}/whitelist/${sellerId}`, data, hdrs(token))); }
      catch (e) { reject(e?.response?.data || e); }
    }),

  removeFromWhitelist: (token, sellerId) =>
    new Promise(async (resolve, reject) => {
      try { resolve(await Axios.delete(`${BASE}/whitelist/${sellerId}`, hdrs(token))); }
      catch (e) { reject(e?.response?.data || e); }
    }),
};
